module.exports = __webpack_public_path__ + "assets/images/03-full_8dc5afd2397b6bc002bc1ad2979c00e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/03-full.png
// module id = 162
// module chunks = 0